import { Usuario } from './usuario.model';
import { Produto } from './produto.model';
import { ItemPedido } from './item-pedido.model';
import { Equipamento } from './equipamento.model';
import { CondicaoPagamento } from './condicao-pagamento.model';
import { Pedido } from './pedido.model';
import { Funcionario } from './func-cliente.model';
import { Banco } from './banco.model';

export  {Usuario, Produto, ItemPedido, Equipamento, 
         CondicaoPagamento, Pedido, Funcionario, Banco};


// WEBPACK FOOTER //
// ./src/app/models/model.ts